// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__Gj-iV","tab":"ProcedureTabs_tab__1k39F"};